import React, { useEffect, useState } from "react";
import { useTheme } from "../../../hooks/useTheme";
import { useSwipeable } from "react-swipeable";

interface TileListProps {
    children: React.ReactNode;
    onTap?: () => void;
    isSelected?: boolean;
    onChangeIsHovered?: (isHovered: boolean) => void;
    childrenSwipped?: React.ReactNode;
    widthSwipedPx?: number;
}

const TileList = ({ children, onTap, isSelected, onChangeIsHovered, childrenSwipped, widthSwipedPx }: TileListProps) => {
    const {isMobile} = useTheme();
    const [isHovered, setIsHovered] = useState(false);

    useEffect(() => {
        if (onChangeIsHovered) {
            onChangeIsHovered(isHovered);
        }
    }, [isHovered, onChangeIsHovered]);

    const handleTap = () => {
        if (onTap) {
            onTap();
        }
    }

    const renderTile = () => {
        return (
            <div className={`${isMobile ? 'px-2' : 'px-4'}`}>
                <div
                    className={`
                    relative cursor-pointer
                    ${
                        isMobile ? 'border-b border-brand-border-color' : 'border-b border-brand-border-color'
                    }
                    `}
                    onClick={handleTap}
                    {...(! isMobile && {
                    onMouseEnter: () => setIsHovered(true),
                    onMouseLeave: () => setIsHovered(false),
                    })}
                >
                    <div
                    className={`px-2 py-2 transition-colors duration-200 rounded-lg
                        ${
                        isSelected && !isMobile
                            ? 'bg-orange-500/30'
                            : isHovered
                            ? 'bg-orange-500/10'
                            : 'bg-transparent'
                        }
                    `}
                    >
                        {children}
                    </div>
                </div>
            </div>
        )
    }

    if(childrenSwipped && widthSwipedPx && isMobile)
        return (
            <SwipeToReveal 
                childrenSwipped={childrenSwipped}
                widthSwipedPx={widthSwipedPx}
            >
                {renderTile()}
            </SwipeToReveal>
        )

    return renderTile();
}

const SwipeToReveal = ({ children, childrenSwipped, widthSwipedPx }: { children: React.ReactNode, childrenSwipped: React.ReactNode, widthSwipedPx: number }) => {
    const [isSwiped, setIsSwiped] = useState(false);
  
    const handlers = useSwipeable({
      onSwipedLeft: () => setIsSwiped(true),
      onSwipedRight: () => setIsSwiped(false),
      preventScrollOnSwipe: true,
      trackMouse: true,
    });
  
    return (
      <div className="flex flex-row items-stretch overflow-hidden">
        <div
          {...handlers}
          className={`transition-transform duration-300 ease-in-out ${
            isSwiped ? `-translate-x-[${widthSwipedPx}px]` : "translate-x-0"
          } grow overflow-hidden`}
        >
          {children}
        </div>
        {isSwiped && childrenSwipped}
      </div>
    );
};

export default TileList;